export const DATA_DE = 'de';
export const DATA_ATE = 'ate';
export const NOME_SOLICITANTE = 'solicitante';
export const NOME_PACIENTE = 'paciente';
export const CPF_PACIENTE = 'cpf';
export const CNS_PACIENTE = 'cns';
export const UF = 'uf';
export const MUNICIPIO = 'municipio';

export const SECOES = {
    DADOS_DO_EXAME: 'dadosDoExame',
    DADOS_DO_PACIENTE: 'dadosDoPaciente',
    INDICACAO_CLINICAS: 'IndicaçãoClínica',
};

/** Chaves exclusivas usadas como `key` em elementos React */
export const REACT_KEYS = {
    BTN_ENVIAR_IMAGENS: 'btn-enviar-imagens',
    SEC_DADOS_DO_EXAME: 'sec-dados-do-exame',
    SEC_DADOS_DO_PACIENTE: 'sec-dados-do-paciente',
    SEC_INDICACAO_CLINICAS: 'sec-indicacao-clinicas'
};
